import _ from 'lodash';
import {observable, computed} from "mobx";
import {observer} from 'mobx-react';
import React from 'react';
import ReactDOM from 'react-dom';
import addContext from './context';

/**
 * Holds a task.
 */
class Task {
  constructor(manager, name, promise, modal) {
    this.manager = manager;
    this.name = name;
    this.promise = promise;
    this.modal = modal;
  }

  remove() {
    this.manager._remove(this);
  }
}

/**
 * Manages all the tasks that are queued.
 */
export class TaskTracker {
  @observable tasks = [];
  context = null;

  @computed get taskCount() {
    return this.tasks.length;
  }

  @computed get containsModal() {
    for (const task of this.tasks) {
      if (task.modal) {
        return true;
      }
    }

    return false;
  }

  add({name, promise, modal = false}) {
    const task = new Task(this, name, promise, modal);
    this.tasks.push(task);
    this._update();
    return promise.then(data => {
      task.remove();
      return data;
    }, e => {
      task.remove();
      return new Promise((resolve, reject) => reject(e));
    });
  }

  log(promise) {
    return this.add({name: 'Working...', promise: promise});
  }

  _remove(task) {
    _.remove(this.tasks, task);
    this._update();
  }

  _update() {
    if (!this.containsModal && this.context) {
      this.context.remove();
      this.context = null;
    } else if (this.containsModal && !this.context) {
      this.context = addContext({
        register: () => {},
        unregister: () => {},
        priority: 1000
      });
    }
  }
}

@observer
class ProgressDisplay extends React.Component {
  render() {
    if (this.props.manager.taskCount) {
      return this.props.manager.containsModal ? (
          <div className="loading-container">
            <div className="loading">
              <div className="loading-spinner-inline"></div>
              &nbsp;{this.props.manager.tasks[0].name}
            </div>
          </div>
        ) : (
          <div className="working-container">
            <div className="working-inner"></div>
          </div>
        );
    } else {
      return <span/>;
    }
  }
}

// Create the manager and append the display to the body
export const manager = new TaskTracker();
const container = document.createElement('div');
document.body.appendChild(container);
ReactDOM.render(<ProgressDisplay manager={manager}/>, container);

export default manager.add.bind(manager);

window.knet = window.knet || {};
window.knet.trackProgress = manager.add.bind(manager);